import Box from "@mui/material/Box";
import MzSelect from "@markaaz/ui/MzSelect";
import { MzMenuItem } from "@markaaz/ui/MzMenuControls";

const sx = {
  root: {
    display: "flex",
    alignItems: "center",
    gap: "20px"
  },
  select: {
    width: "230px"
  },
  selectBox: {
    height: "48px"
  },

  refreshBtn: {
    width: "50px",
    button: {
      backgroundColor: "darkBlue.c20"
    },
    cursor: "pointer"
  },

  refreshToolTip: {
    "& .MuiTooltip-tooltip": {
      width: "53px",
      padding: "6px 12px",
      borderRadius: "5px"
    },
    "& .MuiTooltip-tooltip .MuiTypography-body2": {
      fontSize: "14px",
      lineHeight: "16px",
      textAlign: "center"
    }
  }
};

export default function PartnerList({ partners, isPageLoading, userPartnerId, onPartnerChange }) {
  return (
    <Box sx={sx.root}>
      <Box sx={sx.select}>
        <MzSelect
          fullWidth
          sx={sx.selectBox}
          value={userPartnerId || ""}
          onChange={onPartnerChange}
          disabled={isPageLoading}
          MenuProps={{ style: { maxHeight: 400 } }}
        >
          {partners.map((partner) => {
            return (
              <MzMenuItem key={partner.id} value={partner.id}>
                {partner.name}
              </MzMenuItem>
            );
          })}
        </MzSelect>
      </Box>
    </Box>
  );
}
